<template>
<div>
 <!-- Hero Start -->
<!--        <section class="bg-half bg-light d-table w-100">-->
<!--            <div class="container">-->
<!--                <div class="row justify-content-center">-->
<!--                    <div class="col-lg-12 text-center">-->
<!--                        <div class="title-heading">-->
<!--                            <h4>Blog Or News</h4>-->
<!--                            <p class="text-muted para-desc mx-auto mt-3 mb-0">We present and write attractive blog posts</p>-->
<!--                            <nav aria-label="breadcrumb" class="d-inline-block mt-4">-->
<!--                                <ul class="breadcrumb mb-0">-->
<!--                                    <li class="breadcrumb-item"><a href="index.html">Appdesk</a></li>-->
<!--                                    <li class="breadcrumb-item active" aria-current="page">Blog</li>-->
<!--                                </ul>-->
<!--                            </nav>-->
<!--                        </div>-->
<!--                    </div>&lt;!&ndash;end col&ndash;&gt;-->
<!--                    <div class="home-shape-arrow">-->
<!--                        <a href="blog.html#blog" class="scroll-down"><i class="mdi mdi-arrow-down arrow-icon bg-light text-dark h5"></i></a>-->
<!--                    </div>-->
<!--                </div>&lt;!&ndash;end row&ndash;&gt;-->
<!--            </div> &lt;!&ndash;end container&ndash;&gt;-->
<!--        </section>&lt;!&ndash;end section&ndash;&gt;-->
        <!-- Hero End -->
        <!-- Start BLog -->
        <section class="section" id="blog">
            <div class="container" style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-items: center;margin-top: 4%">
              <h4 class="title mb-4">企业社会责任</h4>
              <div class="col-lg-10">     <p class="text-indent text-muted mb-0">爱拚氪积极践行社会责任。我们郑重承诺，包括但不限于：每个季度拿出一定比例的销售收入，捐赠给红十字会、中西部贫困地区慈善组织、特定弱势群体救助组织等；向中西部贫困地区K12学校用户给予适当让利。</p></div>
                <div class="row justify-center justify-content-center mt-4" >

                    <div class="col-lg-5 col-md-5 col-12 mb-4 pb-3 align-items-center" style="align-items: center;justify-content: center;">

                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                          <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/301621526806_.pic_hd.jpg" class="img-fluid" style="width:600px;height:250px" alt="missing-image">
                        </div>
                      <p  class="text-center" style="font-size: 12px">2021年1月</p>
                    </div><!--end col-->
                  <div class="col-lg-5 col-md-5 col-12 mb-4 pb-3 align-items-center" style="align-items: center;justify-content: center;">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/fp2.jpg" class="img-fluid" style="width:600px;height:250px" alt="missing-image">
                    </div>
                    <p  class="text-center" style="font-size: 12px">2021年4月</p>
                  </div><!--end col-->
                  <div class="col-lg-5 col-md-5 col-12 mb-4 pb-3 align-items-center" style="align-items: center;justify-content: center;">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/fp3.jpg" class="img-fluid" style="width:600px;height:250px" alt="missing-image">
                    </div>
                    <p  class="text-center" style="font-size: 12px">2021年7月</p>
                  </div><!--end col-->
                </div><!--end row-->

            </div><!--end container-->
        </section><!--end section-->
        <!-- End BLog -->


</div>
</template>

<script>


export default {
  components: {
  
  }
}
</script>


